import { hotkeyPrefix, mouseMovePrefix } from '@shared/constants/CommandValues';
import { EnabledPlayDesktopVirtualDeviceTypeId } from '@shared/constants/DeviceIds';
import { isChromeOS, isMac, isWindows } from '@shared/hooks/getDeviceOS';
import { DeviceTypeApplication } from '@shared/models/components/DeviceTypeApplication';
import UserDeviceProfileModel from '@shared/models/deviceProfiles/UserDeviceProfileModel';
import UserDeviceModel from '@shared/models/devices/UserDeviceModel';

// todo: check for isApplication if we have devices where isApplication = false. Currently, we do not support physical devices  Then, default will be connection
export const getDeviceTypeApplication = (device: UserDeviceModel): DeviceTypeApplication => {
    const deviceType = device.device?.deviceType;
    if (!deviceType) return 'application';

    if (deviceType.id === EnabledPlayDesktopVirtualDeviceTypeId) {
        return 'device';
    }

    if (
        deviceType.supportsGenericControllerOutput ||
        deviceType.supportsXboxControllerOutput ||
        deviceType.supportsNintendoControllerOutput ||
        deviceType.supportsPlayStationControllerOutput
    ) {
        return 'game';
    }

    return 'application';
};

// TODO - i18n: consider if we want to internationalize the default device name
export const getNewDeviceName = () => {
    if (isMac()) return 'My Mac';
    if (isWindows()) return 'My PC';
    if (isChromeOS()) return 'My Chromebook';

    return 'My Virtual Device';
};

export const isCommandInProfile = (command: string, profile: UserDeviceProfileModel | null) => {
    if (!profile) {
        return false;
    }

    // check profile configuration
    if (command.toLowerCase().startsWith(mouseMovePrefix) || command.toLowerCase().startsWith(hotkeyPrefix)) {
        return true;
    }

    if (
        profile?.configuration?.audioEvents?.some((a) =>
            a.commands?.some((c) => c.toLowerCase() == command.toLowerCase())
        )
    ) {
        return true;
    }
    if (profile?.configuration?.macros?.some((m) => m.commands.some((c) => c.toLowerCase() == command.toLowerCase()))) {
        return true;
    }
    if (
        profile?.configuration?.commandKeyMappings?.some((c) =>
            c.commands?.some((cc) => cc.toLowerCase() == command.toLowerCase())
        )
    ) {
        return true;
    }

    return false;
};
